import { connect } from 'react-redux';

const mapStateToProps = state => ({
  hasApplePay: state.app.applePay,
});

export default connect(mapStateToProps);



// WEBPACK FOOTER //
// ./src/app/hoc/WithApplePay.js